/**
 * Utility functions for Colombia Standard Time (GMT-5 / America/Bogota)
 * Garantiza que la trazabilidad de órdenes, bitácora de sucesos y gestor de resguardos
 * utilicen de forma estandarizada la Hora Oficial de Colombia.
 */

export const COLOMBIA_TIMEZONE = 'America/Bogota';

/**
 * Formatea una fecha o string ISO a la hora oficial de Colombia (DD/MM/YYYY, hh:mm:ss a.m./p.m.)
 */
export function formatColombiaDateTime(dateInput?: Date | string | number | null, includeSeconds = true): string {
  if (!dateInput) return 'N/A';
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return 'Fecha inválida';

  try {
    return new Intl.DateTimeFormat('es-CO', {
      timeZone: COLOMBIA_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: includeSeconds ? '2-digit' : undefined,
      hour12: true
    }).format(date);
  } catch (e) {
    return date.toLocaleString('es-CO');
  }
}

/**
 * Formatea únicamente la fecha en zona horaria de Colombia (DD/MM/YYYY)
 */
export function formatColombiaDate(dateInput?: Date | string | number | null): string {
  if (!dateInput) return 'N/A';
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return 'Fecha inválida';

  try {
    return new Intl.DateTimeFormat('es-CO', {
      timeZone: COLOMBIA_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
  } catch (e) {
    return date.toLocaleDateString('es-CO');
  }
}

/**
 * Formatea únicamente la hora en zona horaria de Colombia (hh:mm:ss a.m./p.m.)
 */
export function formatColombiaTime(dateInput?: Date | string | number | null, includeSeconds = true): string {
  if (!dateInput) return 'N/A';
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return 'Hora inválida';

  try {
    return new Intl.DateTimeFormat('es-CO', {
      timeZone: COLOMBIA_TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      second: includeSeconds ? '2-digit' : undefined,
      hour12: true
    }).format(date);
  } catch (e) {
    return date.toLocaleTimeString('es-CO');
  }
}

/**
 * Retorna la fecha y hora actual formateada con indicador explícito de Colombia (GMT-5)
 */
export function getColombiaCurrentClockString(): string {
  const now = new Date();
  return `${formatColombiaDateTime(now, true)} (COT GMT-5)`;
}
